export default __webpack_public_path__ + "static/media/tips.50f8a864.png";